import { d as defineProperties_1 } from '../define-properties/index.js';
import { p as polyfill } from './polyfill.js';

var define = defineProperties_1;
var getPolyfill = polyfill;

var shim = function shimAssign() {
	var polyfill = getPolyfill();
	define(
		Object,
		{ assign: polyfill },
		{ assign: function () { return Object.assign !== polyfill; } }
	);
	return polyfill;
};

export { shim as s };
